import { showModal } from "@/ui/Modal2";
import { useCallback } from "react";

const PASS_RESPONSE = "pass";

const createSMSModalGuardResponse = (code?: string) => ({
  getCode: () => {
    if (code === PASS_RESPONSE) {
      return undefined;
    }

    return code;
  },
  pass: () => {
    return !!code;
  },
});

type SMSModalGuardOptions = {
  title?: string;
  oldValue?: unknown;
  newValue?: unknown;
};

export const useSMSModalGuard = () => {
  const smsGuard = useCallback(async (options: SMSModalGuardOptions) => {
    /** If there was a previous value and the new one differs, show SMS guard. */
    if (options.oldValue && options.oldValue !== options.newValue) {
      const modalResponse = await showModal("sms-wall", options);
      return createSMSModalGuardResponse(modalResponse);
    }

    return createSMSModalGuardResponse(PASS_RESPONSE);
  }, []);

  return { smsGuard };
};
